import { render, staticRenderFns } from "./i4pro.vue?vue&type=template&id=4d2e6132&scoped=true"
import script from "./i4pro.vue?vue&type=script&lang=js"
export * from "./i4pro.vue?vue&type=script&lang=js"
import style0 from "./i4pro.vue?vue&type=style&index=0&id=4d2e6132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2e6132",
  null
  
)

export default component.exports